import Vue from "vue";
import Vuex from "vuex";
import init from "@/store/init";
Vue.use(Vuex);

const state = {
  ready: false,
  user: null,
  menu: null,
  descriptors: null,
  options: null,
  schemas: null
};

const mutations = {
  READY: state => {
    state.ready = true;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_MENU: (state, menu) => {
    state.menu = menu;
  },
  SET_DESCRIPTORS: (state, descriptors) => {
    state.descriptors = descriptors;
  },
  SET_OPTIONS: (state, options) => {
    state.options = options;
  },
  SET_SCHEMAS: (state, schemas) => {
    state.schemas = schemas;
  }
};

const actions = {
  ready({ commit }) {
    commit("READY");
  },
  setUser({ commit }, user) {
    commit("SET_USER", user);
  },
  setMenu({ commit }, menu) {
    commit("SET_MENU", menu);
  },
  setDescriptors({ commit }, descriptors) {
    commit("SET_DESCRIPTORS", descriptors);
  },
  setOptions({ commit }, options) {
    commit("SET_OPTIONS", options);
  },
  setSchemas({ commit }, schemas) {
    commit("SET_SCHEMAS", schemas);
  }
};

const getters = {
  ready: state => state.ready,
  user: state => state.user,
  menu: state => state.menu,
  descriptors: state => state.descriptors,
  options: state => state.options,
  schemas: state => state.schemas
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

store.init = init(store);

export default store;
